import styled from 'styled-components';

const CompletionContainer = styled.div`
  .Completion-Title {
  }

  .Completion-Paragraph {
    margin-top: 47px;
    margin-bottom: 47px;
  }

  .Completion-Img {
    width: 100%;
  }
`;

export default CompletionContainer;
